module.exports = __webpack_public_path__ + "img/feather.ad83dd4e.webp";